import React from 'react';

// Subtle "(en inglés)" marker for links that lead to English-only pages
export const EnOnlyNote = ({ text, testId }) =>
  text ? (
    <span className="ml-1 text-xs font-normal opacity-70 whitespace-nowrap" data-testid={testId}>
      {text}
    </span>
  ) : null;
